import { render, staticRenderFns } from "./GroupInfo.vue?vue&type=template&id=485f2ce1&scoped=true"
import script from "./GroupInfo.vue?vue&type=script&lang=js"
export * from "./GroupInfo.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/group_information.css?vue&type=style&index=0&id=485f2ce1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f2ce1",
  null
  
)

export default component.exports